import { Card } from 'antd'
import TableHasPagenation from '../../../components/TableHasPagenation'
const basicColumns = [
  {
    title: '商品名称',
    dataIndex: 'productName',
    render: (text, record) => (
      <div style={{ fontSize: 12 }}>
        <div style={{ color: '#1890ff' }}>{record.productName}</div>
        <div>商品编码：{record.productCode}</div>
        <div>商品条码：{record.barcode}</div>
      </div>
    )
  },
  {
    title: '商品类别',
    dataIndex: 'categoryName'
  },
  {
    title: '规格',
    dataIndex: 'specification'
  },
  {
    title: '单位',
    dataIndex: 'unit'
  },
  {
    title: '当前剩余库存',
    dataIndex: 'stock',
    sorter: true,
    showSorterTooltip: false,
    render: (text) => (
        <div style={{ fontSize: 12 }}>
          {text || '-'}
        </div>
    )
  }
]

export default function ProductListBasicTable({
  pageData,
  otherColumns = [],
  rowSelection = null,
  getList,
  onTableChange,
  loading
}) {
  const columns = [
    {
      title: '序号',
      // dataIndex: 'id'
      render: (text, record, index) =>
        (pageData.pageIndex - 1) * pageData.pageSize + (index + 1)
    },
    ...basicColumns,
    ...otherColumns
  ]
  return (
    <TableHasPagenation
      rowSelection={rowSelection}
      rowKey={record => record.id + record.skuId}
      loading={loading}
      onPageSizeChange={getList}
      onTableChange={onTableChange}
      pageData={pageData}
      columns={columns}
    />
  )
}
